<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kGOqb2/tc-custom/9789948798002.jpg?1705688365792" alt="This image is the cover for the book بين الجحيم والإنسانية"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">بين الجحيم والإنسانية
      </h1>
      <p class="bookDescription body article font2">
        <p>كانت أحلامي كلها تكسرت على صخرة اعتقالي، وما إنْ بدأتُ بإدراك ما حولي حتى بدأ يتكشَّفُ لي هولُ الكارثة وعِظَمُها شيئاً فشيئاً. وإن ما كان يدور في أقبية الأمن ومراكز الاعتقال ما هو إلا جزء يسير من تلك الحالة في هذا البلد. لقد كانت حرباً قذرة بكل ما تعنيه الكلمة، كانت البيوت تتهدَّم فوق ساكينها، وعوائل كاملة كانت تختفي تحت أنقاض المباني لتصبح "أثراً بعد عين". كانت البراميل المتفجِّرة تنشر الرعب في كل مكان والأسلحة الكيماوية قد فعلت فعلها وأخذت حصتها من القتل. لقد ماتت أمي بقذيفة طائشة نزلت في حينها على قريتنا دون سابق إنذار، لم تكن تبعد كثيراً عن بيتنا، وحصدت معها طفلتين صغيرتين لأبناء الجيران كانتا في طريقهما إلى بقالة أبي حُسين.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        أكرم البرجس
      </h2>
      
      <p class="authorDescription body article">أكرم البرجس، بدأ حياته في مدرسة القرية، ثم أكملَ تعليمه الثانوي في ثانوية أبي العلاء المعري، تخرج في كلية التربية في إدلب بصفة مدرس. عمل في مدارس المملكة العربية السعودية لمدة عشر سنوات ليعود بعدها مع بدء الحراك الثوري، ويكون مِن أنصار الحراك السلمي ونبذ العنف والطائفيَّة.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b9b24a1